import React, { useState, useCallback, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18next from "i18next";
import translations from './util/translations';
import { Provider } from 'react-redux'
import { DEFAULT_LANGUAGE } from './util/constants';
import store from './redux/store';
import AppRouter from './AppRouter';
import Snackbar from './components/Snackbar';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import getTheme from './theme';
import moment from 'moment'
import 'moment/locale/tr'
import eventBus from './EventBus'

// Initialize moment
moment.locale(DEFAULT_LANGUAGE)

// Initialize translation
i18next.init({
    interpolation: { escapeValue: false },
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    resources: translations,
});

store.subscribe(() => {
    // const state = store.getState()
    // console.log(state)
})

const App = () => {

    // Get browsers theme
    const [isDark, setIsDark] = useState(
        // window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
        false
    );
    // Theme setter
    const themeSetter = useCallback(e => {
        setIsDark(!!e.matches)
    }, [])

    eventBus.on("darkMode", (data) => {
        const isDarkModeChecked = data.isDarkMode
        setIsDark(isDarkModeChecked)
    })

    useEffect(() => {

        // Watch changes of browser theme
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', themeSetter);
        // Clean listener
        return () => window.removeEventListener("change", themeSetter);

        // eslint-disable-next-line
    }, []);

    return (
        <I18nextProvider i18n={i18next}>
            <Provider store={store}>
                <CssBaseline />
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={getTheme(isDark)}>
                        <AppRouter />
                        <Snackbar />
                    </ThemeProvider>
                </StyledEngineProvider>
            </Provider>
        </I18nextProvider>
    );

}

export default App
